import { render, staticRenderFns } from "./CertificateMail.vue?vue&type=template&id=2e7d54e9&scoped=true"
import script from "./CertificateMail.vue?vue&type=script&lang=js"
export * from "./CertificateMail.vue?vue&type=script&lang=js"
import style0 from "./CertificateMail.vue?vue&type=style&index=0&id=2e7d54e9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7d54e9",
  null
  
)

export default component.exports